import { render, staticRenderFns } from "./Polygon.vue?vue&type=template&id=ae8aa5c6"
import script from "./Polygon.js?vue&type=script&lang=js&external"
export * from "./Polygon.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports